import React from 'react';
interface PhoneFrameProps {
  children: React.ReactNode;
  className?: string;
  screenClassName?: string;
  /** Screen proportion. Keep it just tall enough for the content inside. */
  aspectClassName?: string;
}

/** A black iPhone built in HTML/CSS. Screen content is real art and live text. */
export function PhoneFrame({
  children,
  className = '',
  screenClassName = 'bg-cream',
  aspectClassName = 'aspect-[9/18]'
}: PhoneFrameProps) {
  return <div className={`rounded-[2.1rem] bg-[#14121C] p-[6px] shadow-phone ring-1 ring-black/60 ${className}`} data-id="element-288" data-mp="27m200g8ska06">
      <div className={`relative overflow-hidden rounded-[1.75rem] ${aspectClassName} ${screenClassName}`} data-id="element-289" data-mp="2bnf8yz76ktbb">
        <span aria-hidden="true" className="absolute left-1/2 top-2 z-10 h-[14px] w-[32%] -translate-x-1/2 rounded-full bg-[#14121C]" data-id="element-290" data-mp="2ljqjpkr4hb3n" />
        {children}
      </div>
    </div>;
}